export default "__VITE_ASSET__wxkngcja__"